// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-config-device .title[data-v-34cc5fa4]{position:relative}.layout-config-device .title .extra[data-v-34cc5fa4]{position:absolute;right:10px;top:0}.layout-config-device .tabs-warp[data-v-34cc5fa4]{position:relative;height:calc(100% - 40px)}.layout-config-device .tabs-warp[data-v-34cc5fa4] .ivu-tabs-content{position:absolute;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
